/** Treat blank text inputs as absent optional values for Zod `.optional()` fields. */
export const optionalString = (value: unknown) => (value === '' ? undefined : value);

/** Treat blank selects as absent optional UUID fields for Zod `.uuid().optional()`. */
export const optionalUuid = (value: unknown) => (value === '' || value == null ? undefined : String(value));
